import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { AssertiveLoaderComponent } from './assertive-loader.component'
import { MaterialModule } from '@app/shared/material.module'

@NgModule({
	declarations: [AssertiveLoaderComponent],
	imports: [CommonModule, MaterialModule],
	exports: [AssertiveLoaderComponent],
})
export class AssertiveLoaderModule {}
